import { Type, type Static } from "@sinclair/typebox";
import {
  TEMPORARY_FILE_REFERENCE_LIMIT,
  TemporaryFileReferenceSchema
} from "./document-platform.ts";

export const TEMPORARY_FILE_MESSAGE_CONTENT_KEY =
  "io.matrix_idp.message.temporary_files" as const;

export const TemporaryFileMessageContentSchema = Type.Object(
  {
    version: Type.Literal("1.0"),
    files: Type.Array(TemporaryFileReferenceSchema, {
      minItems: 1,
      maxItems: TEMPORARY_FILE_REFERENCE_LIMIT,
      uniqueItems: true
    })
  },
  { additionalProperties: false }
);

export type TemporaryFileMessageContentV1 = Static<typeof TemporaryFileMessageContentSchema>;
